import { getNoticeAll, getNoticeOne } from "api/api";
import Loading from "components/common/Loading";
import dayjs from "dayjs";
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import hubLayout from 'styles/css/hubLayout.module.css';
import { Notice } from "type/type";

dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.tz.setDefault('Asia/Seoul');

export function UserNoticeList() {
  // ****************************** 1. props, hook
  const navigate = useNavigate();
  
  // ****************************** 2. state
  const [loading, setLoading] = useState(false);
  const [noticeList, setNoticeList] = useState<Notice[]>([]);
  // 페이지네이션
  const limit = 1000; // 보여줄 게시물 개수
  const page = 1; // 현재 페이지

  // ****************************** 3. api
  // 공지사항 리스트 가져오기
  const getNoticeList = async (pageNo: number, pageSize: number) => {
    try {
      setLoading(false);
      const result = await getNoticeAll(pageNo, pageSize, {is_use:1, type: 'normal'});
      if (result.code === 200) {
        const noticeList = result.data.sort((a: Notice, b: Notice) => { 
          return dayjs(b.create_date).valueOf() - dayjs(a.create_date).valueOf();   
        });
        setNoticeList(noticeList);
      }
      setLoading(true);
    } catch (error) {
      console.error("error ", error);
    }
  }

  // ****************************** 4. event handler

  // ****************************** 5. useEffect
  useEffect(() => {
    getNoticeList(page, limit);
  }, [page, limit]);

  return (
    <>
      {!loading ? <Loading /> : 
        <>
          <div className={`${hubLayout.cnt_box}`} style={{ overflowY: "auto" }}>
            <div className={`${hubLayout.acc__cnt}`} style={{ padding: "0 20px 20px 20px" }}>
              <p className={`${hubLayout.acc_total}`} style={{ margin: '0.5rem 0 0 0' }}>총 <strong className={`${hubLayout.tx_blue}`}>{noticeList.length}</strong>개</p>
              <div className={`${hubLayout.acc_total}`} style={{ margin: '0rem', textAlign: 'center' }}>
                {noticeList.length === 0 ?
                  <li className={`${hubLayout.acc_item}`}>
                    <div className={`${hubLayout.acc_item_info}`}>
                      <dl>
                        <dd style={{ textAlign: "center" }}>등록된 공지사항이 없습니다.</dd>
                      </dl>
                    </div>
                  </li>
                  :
                  noticeList.map((notice, index) =>
                    <li key={`notice_${index}`} className={`${hubLayout.acc_item}`} style={{ margin: '0.5rem' }}>
                      <div className={`${hubLayout.acc_item_info}`} onClick={()=> navigate(`/user/notice/detail/${notice.idx}`)} style={{ padding: '0.5rem' }}>
                        <dd style={{ textAlign: "left", padding: "0.5rem", wordWrap: "break-word" }}>{ notice.title }</dd>
                        <dt style={{ textAlign: "left", paddingLeft: "0.5rem", fontSize: "13px", color: "#4f4f4f" }}>{dayjs.tz(notice.start_date).format('YYYY-MM-DD')}</dt>
                      </div>
                    </li>
                  )
                }
              </div>
            </div>
          </div>
        </>
      }
    </>
  );
}

export function UserNoticeDetail() {
  // ****************************** 2. state
  const { noticeIdx } = useParams();
  const [loading, setLoading] = useState(false);
  const [notice, setNotice] = useState<Notice>();

  // 공지사항 가져오기
  const getNotice = async () => {
    try {
      setLoading(true);
      const result = await getNoticeOne(Number(noticeIdx));
      if (result.code === 200) {
        setNotice(result.data);
      }
      setLoading(false);
    } catch (error) {
      console.error("error ", error);
    }
  }
  useEffect(() => {
    getNotice();
  }, [noticeIdx]);
  return (
    <>
      {loading ? <Loading /> : 
        <>
          <div className={`${hubLayout.cnt_box}`} style={{ overflowY: "auto" }}>
            <div className={`${hubLayout.acc__cnt}`} style={{ padding: "0 20px 20px 20px" }}>
              {!notice ?
                <h2 className={`${hubLayout.cnt_title} ${hubLayout.tx_blue}`}>해당 공지사항이 없습니다.</h2>
                : (
                  <>
                    <h2 className={`${hubLayout.cnt_title}`} style={{ width: "100%", textAlign: "left", padding: "0.5rem", wordWrap: "break-word", lineHeight: '1.5rem' }}>{notice.title}</h2>
                    <div className={`${hubLayout.acc_total}`} style={{ margin: '0', textAlign: 'center', borderBottom: "0" }}>
                      <li className={`${hubLayout.acc_item}`}>
                        <div className={`${hubLayout.acc_item_info}`}>
                          <dl style={{ margin: '0' }}>
                            {/* 이미지가 있으면 표시. 클릭시 redirect_url 로 이동 */}
                            {notice.send_file &&
                              <img src={notice.send_file} alt={notice.title} style={{width: '100%'}} onClick={()=> notice.redirect_url && (window.location.href = notice.redirect_url)} />
                            }
                          </dl>
                          <dl>
                            <dd style={{ width: "100%", textAlign: "left", padding: "0.5rem", wordWrap: "break-word" }}>{notice.content}</dd>
                          </dl>
                        </div>
                      </li>
                    </div>
                  </>
                )
              }
            </div>
          </div>
        </>
      }
    </>
  );
}